// STYLES
import styles from './badge-counter.module.scss';

export interface BadgeCounterProps {
	'className'?: string;
	'content': number;
	'data-testid'?: string;
	'size'?: string;
}

export const BadgeCounter = ({
	className,
	content,
	'data-testid': dataTestid,
	size,
}: BadgeCounterProps) => {

	const cssClasses = [
		styles.badgecounter,
	];

	if (size === 'small') cssClasses.push(styles.size__small);

	if (className) cssClasses.push(className);

	return (
		<div
			className={cssClasses.join(' ')}
			data-testid={dataTestid}
		>
			{content}
		</div>
	);
};
